/* Hawcrest – Size Assistant (apparel + shoes), vanilla JS, no dependencies.
   Config lives in snippets/hc-size-assistant.liquid (#hc-sa-config).
   Pure helpers are exposed on window.HawcrestSA for testing.

   SIZE LOGIC (documented charts)
   ------------------------------
   1) Chest/bust estimate from height (in) and weight (lb):
        men / unisex : chest = 0.11 * lb + 0.18 * in + 9
        women        : bust  = 0.12 * lb + 0.12 * in + 11
      Calibration points: men 5'10"/170 lb ≈ 40" (M/L border), 6'0"/200 lb ≈ 44" (L/XL),
      women 5'5"/140 lb ≈ 35.6" (M), 5'4"/120 lb ≈ 33" (S).
   2) Letter-size bands (inches, lower bound inclusive):
        men   chest: XS 32–35 · S 35–38 · M 38–41 · L 41–44 · XL 44–47 · XXL 47–51 · 3XL 51–55 · 4XL 55–59
        women bust : XS 30.5–33 · S 33–35 · M 35–37 · L 37–40 · XL 40–43 · XXL 43–47 · 3XL 47–51 · 4XL 51–55
      The position inside a band gives a fractional size index (XS = 0, S = 1, M = 2 …).
   3) Adjustments in size units: build slim −0.5 / broad +0.5, fit snug −0.5 / relaxed +0.5,
      jackets +0.25 (room for layering). Final size = floor(index + adjustments).
   4) Pants: waist ≈ chest − 6.5 in (men) / bust − 8 in (women), ±1 in per half size of adjustment.
      Inseam by height: under 5'7" → 30, under 6'0" → 32, otherwise 34 (clamped to what the product offers).
   5) Women's numeric: XS 0–2, S 4–6, M 8–10, L 12–14, XL 16, XXL 18, 3XL 20, 4XL 22
      (lower number if the index sits in the lower half of the band).
   6) EU apparel: men XS 44 … 4XL 58 (steps of 2), women XS 34 … 4XL 48 (steps of 2).
   7) Shoes: common US length chart (foot length in inches = longest foot, heel to longest toe);
      we recommend the smallest size whose length is at least the foot length (between sizes → go up). */
(function () {
  'use strict';

  /* ---------- shared modal helper (same as in hc-gift-finder.js) ---------- */
  if (typeof window !== 'undefined' && !window.HawcrestModal && typeof document !== 'undefined') {
    window.HawcrestModal = (function () {
      var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
      var active = null;
      function focusables(el) {
        return Array.prototype.filter.call(el.querySelectorAll(FOCUSABLE), function (n) {
          return n.offsetWidth > 0 || n.offsetHeight > 0 || n === document.activeElement;
        });
      }
      function onKey(e) {
        if (!active) return;
        if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
        if (e.key !== 'Tab') return;
        var list = focusables(active.dialog);
        if (!list.length) { e.preventDefault(); active.dialog.focus(); return; }
        var first = list[0], last = list[list.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === active.dialog)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      function open(modal, trigger) {
        if (!modal) return;
        if (active) close(true);
        var dialog = modal.querySelector('[role="dialog"]');
        active = { modal: modal, dialog: dialog, trigger: trigger || document.activeElement };
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('hc-modal-open');
        document.addEventListener('keydown', onKey, true);
        setTimeout(function () {
          var target = dialog.querySelector('[data-hc-autofocus]') || dialog;
          try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
        }, 30);
      }
      function close(silent) {
        if (!active) return;
        var a = active;
        active = null;
        a.modal.hidden = true;
        a.modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('hc-modal-open');
        document.removeEventListener('keydown', onKey, true);
        if (!silent && a.trigger && typeof a.trigger.focus === 'function' && document.contains(a.trigger)) {
          try { a.trigger.focus({ preventScroll: true }); } catch (err) { a.trigger.focus(); }
        }
        a.modal.dispatchEvent(new CustomEvent('hc:closed'));
      }
      function bindClose(modal) {
        modal.addEventListener('click', function (e) {
          if (e.target.closest('[data-hc-close]')) { e.preventDefault(); close(); }
        });
      }
      function afterAdd(item) {
        try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } })); } catch (e) {}
        close(true);
        setTimeout(function () {
          var drawer = document.getElementById('CartDrawer');
          var isOpen = drawer && (drawer.classList.contains('drawer--is-open') || drawer.classList.contains('is-open'));
          if (!isOpen) {
            var link = document.querySelector('.js-drawer-open-cart');
            if (link) link.click();
            else window.location.href = '/cart';
          }
        }, 450);
      }
      function addToCart(variantId) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        }).then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok || data.status) throw new Error(data.description || data.message || 'add failed');
            return data;
          });
        });
      }
      return { open: open, close: close, bindClose: bindClose, afterAdd: afterAdd, addToCart: addToCart };
    })();
  }

  /* ---------- pure helpers ---------- */
  var LETTERS = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL']; /* index 0..8, XXS = -1 */
  var LETTER_ALIASES = {
    'XXS': -1, '2XS': -1, 'XXSMALL': -1, '2XSMALL': -1,
    'XS': 0, 'XSMALL': 0, 'EXTRASMALL': 0,
    'S': 1, 'SM': 1, 'SMALL': 1,
    'M': 2, 'MD': 2, 'MED': 2, 'MEDIUM': 2,
    'L': 3, 'LG': 3, 'LARGE': 3,
    'XL': 4, 'XLARGE': 4, 'EXTRALARGE': 4, '1X': 4, '1XL': 4,
    'XXL': 5, '2XL': 5, '2X': 5, 'XXLARGE': 5, '2XLARGE': 5,
    'XXXL': 6, '3XL': 6, '3X': 6, 'XXXLARGE': 6, '3XLARGE': 6,
    'XXXXL': 7, '4XL': 7, '4X': 7,
    'XXXXXL': 8, '5XL': 8, '5X': 8
  };
  function letterIndex(value) {
    if (value == null) return null;
    var raw = String(value).toUpperCase();
    var whole = raw.replace(/[\s.\-_'’]/g, '');
    if (Object.prototype.hasOwnProperty.call(LETTER_ALIASES, whole)) return LETTER_ALIASES[whole];
    var first = raw.split(/[\s(\/,|]+/).filter(Boolean)[0];
    if (first) {
      first = first.replace(/[.\-_'’]/g, '');
      if (Object.prototype.hasOwnProperty.call(LETTER_ALIASES, first)) return LETTER_ALIASES[first];
    }
    return null;
  }
  var BANDS = {
    men: [32, 35, 38, 41, 44, 47, 51, 55, 59],
    women: [30.5, 33, 35, 37, 40, 43, 47, 51, 55]
  };
  function chestEstimate(gender, heightIn, weightLb) {
    if (gender === 'women') return 0.12 * weightLb + 0.12 * heightIn + 11;
    return 0.11 * weightLb + 0.18 * heightIn + 9;
  }
  function chestToIndex(gender, chest) {
    var b = BANDS[gender === 'women' ? 'women' : 'men'];
    if (chest < b[0]) return -1 + Math.max(0, (chest - (b[0] - 3)) / 3);
    for (var i = 0; i < b.length - 1; i++) {
      if (chest < b[i + 1]) return i + (chest - b[i]) / (b[i + 1] - b[i]);
    }
    return b.length - 1.01;
  }
  function adjustment(build, pref, fit) {
    var a = 0;
    if (build === 'slim') a -= 0.5;
    if (build === 'broad') a += 0.5;
    if (pref === 'snug') a -= 0.5;
    if (pref === 'relaxed') a += 0.5;
    if (fit === 'jackets') a += 0.25;
    return a;
  }
  function inseamForHeight(heightIn) {
    if (heightIn < 67) return 30;
    if (heightIn < 72) return 32;
    return 34;
  }
  /* answers: { gender, fit, heightIn, weightLb, build, pref } */
  function recommendApparel(a) {
    var gender = a.gender === 'women' ? 'women' : 'men';
    var chest = chestEstimate(gender, a.heightIn, a.weightLb);
    var adj = adjustment(a.build, a.pref, a.fit);
    var f = chestToIndex(gender, chest) + adj;
    var idx = Math.floor(f);
    if (idx < -1) idx = -1;
    if (idx > 8) idx = 8;
    var frac = Math.min(Math.max(f - Math.floor(f), 0), 0.999);
    var waist = gender === 'women' ? chest - 8 : chest - 6.5;
    waist = Math.round(waist + adj * 2);
    return { gender: gender, chest: chest, index: idx, frac: frac, letter: idx < 0 ? 'XXS' : LETTERS[idx], waist: waist, inseam: inseamForHeight(a.heightIn) };
  }
  var WOMEN_NUMERIC = { '-1': [0], 0: [0, 2], 1: [4, 6], 2: [8, 10], 3: [12, 14], 4: [16], 5: [18], 6: [20], 7: [22], 8: [24] };
  function womenNumericToIndex(n) {
    if (n <= 2) return 0; if (n <= 6) return 1; if (n <= 10) return 2; if (n <= 14) return 3;
    if (n <= 16) return 4; if (n <= 18) return 5; if (n <= 20) return 6; if (n <= 22) return 7; return 8;
  }
  function euToIndex(gender, n) {
    var base = gender === 'women' ? 34 : 44;
    return Math.round((n - base) / 2);
  }
  function parseWaistInseam(v) {
    var m = String(v).match(/(\d{2})\s*(?:[\/xX×]|\s*W?\s*\/?\s*L)\s*(\d{2})/);
    if (!m) m = String(v).match(/W\s*(\d{2})\s*\/?\s*L\s*(\d{2})/i);
    return m ? { waist: parseInt(m[1], 10), inseam: parseInt(m[2], 10) } : null;
  }
  function leadingNumber(v) {
    var m = String(v).replace(',', '.').match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : null;
  }
  function detectSystem(values, gender, fit) {
    var vals = (values || []).filter(function (v) { return v != null && String(v).trim() !== ''; });
    if (!vals.length) return 'unknown';
    var letters = vals.filter(function (v) { return letterIndex(v) !== null; }).length;
    if (letters >= Math.ceil(vals.length / 2)) return 'letter';
    var wi = vals.filter(function (v) { return parseWaistInseam(v); }).length;
    if (wi >= Math.ceil(vals.length / 2)) return 'waist_inseam';
    if (vals.some(function (v) { return /\bEU\b/i.test(v); })) return 'eu';
    var nums = vals.map(leadingNumber).filter(function (n) { return n !== null; });
    if (nums.length < Math.ceil(vals.length / 2)) return 'unknown';
    var min = Math.min.apply(null, nums), max = Math.max.apply(null, nums);
    if (fit === 'pants' && min >= 24 && max <= 48 && !(gender === 'women' && max <= 24)) return 'waist';
    if (max <= 24) return 'women_numeric';
    if (min >= 32 && max <= 60) return 'eu';
    if (min >= 24 && max <= 48) return 'waist';
    return 'unknown';
  }
  /* Rank candidate values by distance to a target number; ties go to the larger size. */
  function nearestBy(values, metric, target) {
    var best = null, bestD = Infinity, bestM = -Infinity;
    values.forEach(function (v) {
      var m = metric(v);
      if (m === null || isNaN(m)) return;
      var d = Math.abs(m - target);
      if (d < bestD - 1e-9 || (Math.abs(d - bestD) < 1e-9 && m > bestM)) { best = v; bestD = d; bestM = m; }
    });
    return best;
  }
  /* Returns { system, target, exact: value|null, nearest: value|null }.
     allValues = every size value on the product; availableValues = those with an available variant. */
  function mapApparel(rec, allValues, availableValues, fit) {
    var system = detectSystem(allValues, rec.gender, fit);
    var metric, target, label;
    if (system === 'letter') {
      metric = letterIndex; target = rec.index; label = rec.letter;
    } else if (system === 'women_numeric') {
      var opts = WOMEN_NUMERIC[rec.index] || [rec.index];
      target = rec.frac < 0.5 || opts.length === 1 ? opts[0] : opts[opts.length - 1];
      metric = leadingNumber; label = String(target);
    } else if (system === 'eu') {
      var base = rec.gender === 'women' ? 34 : 44;
      target = base + Math.max(rec.index, 0) * 2;
      metric = leadingNumber; label = 'EU ' + target;
    } else if (system === 'waist') {
      target = rec.waist; metric = leadingNumber; label = String(target);
    } else if (system === 'waist_inseam') {
      var pairs = allValues.map(function (v) { return { v: v, p: parseWaistInseam(v) }; }).filter(function (x) { return x.p; });
      var waists = pairs.map(function (x) { return x.p.waist; });
      var w = nearestBy(waists, function (n) { return n; }, rec.waist);
      var inseams = pairs.filter(function (x) { return x.p.waist === w; }).map(function (x) { return x.p.inseam; });
      var i = nearestBy(inseams, function (n) { return n; }, rec.inseam);
      var exactPair = pairs.filter(function (x) { return x.p.waist === rec.waist && x.p.inseam === i; })[0];
      var targetCombo = rec.waist * 100 + rec.inseam;
      var comboMetric = function (v) { var p = parseWaistInseam(v); return p ? p.waist * 100 + p.inseam : null; };
      var availPairs = availableValues.filter(function (v) { return parseWaistInseam(v); });
      var nearestAvail = nearestBy(availPairs, comboMetric, rec.waist * 100 + (i || rec.inseam));
      return {
        system: system, label: rec.waist + '/' + (i || rec.inseam),
        exact: exactPair ? exactPair.v : null,
        nearest: exactPair && availableValues.indexOf(exactPair.v) > -1 ? exactPair.v : nearestAvail,
        targetCombo: targetCombo
      };
    } else {
      return { system: 'unknown', label: rec.letter, exact: null, nearest: null };
    }
    var exact = allValues.filter(function (v) { var m = metric(v); return m !== null && m === target; })[0] || null;
    var nearest = nearestBy(availableValues, metric, target);
    return { system: system, label: label, exact: exact, nearest: nearest };
  }

  /* Shoes: [US size, foot length in inches] */
  var SHOE_CHART = {
    men: [[6, 9.25], [6.5, 9.5], [7, 9.625], [7.5, 9.75], [8, 9.9375], [8.5, 10.125], [9, 10.25], [9.5, 10.4375], [10, 10.5625], [10.5, 10.75], [11, 10.9375], [11.5, 11.125], [12, 11.25], [13, 11.5625], [14, 11.875], [15, 12.1875], [16, 12.5]],
    women: [[4, 8.1875], [4.5, 8.375], [5, 8.5], [5.5, 8.75], [6, 8.875], [6.5, 9.0625], [7, 9.25], [7.5, 9.375], [8, 9.5], [8.5, 9.6875], [9, 9.875], [9.5, 10], [10, 10.1875], [10.5, 10.3125], [11, 10.5], [11.5, 10.6875], [12, 10.875]]
  };
  var EU_TO_US = {
    men: { 38: 5.5, 39: 6.5, 40: 7, 41: 8, 42: 8.5, 43: 9.5, 44: 10, 45: 11, 46: 12, 47: 12.5, 48: 13.5, 49: 14.5 },
    women: { 35: 5, 36: 6, 37: 6.5, 38: 7.5, 39: 8, 40: 9, 41: 9.5, 42: 10.5, 43: 11.5, 44: 12 }
  };
  function shoeSizeFromLength(gender, inches) {
    var chart = SHOE_CHART[gender === 'women' ? 'women' : 'men'];
    for (var i = 0; i < chart.length; i++) { if (chart[i][1] >= inches - 1e-6) return chart[i][0]; }
    return chart[chart.length - 1][0];
  }
  function parseFraction(s) {
    s = String(s).replace('½', '.5').replace(/(\d+)\s+1\/2/, '$1.5');
    var m = s.replace(',', '.').match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : null;
  }
  function euToUs(gender, eu) {
    var table = EU_TO_US[gender === 'women' ? 'women' : 'men'];
    var keys = Object.keys(table).map(Number);
    var k = nearestBy(keys, function (n) { return n; }, eu);
    if (k === null) return null;
    if (Math.abs(k - eu) < 0.01) return table[k];
    /* half EU sizes: interpolate between neighbours */
    var lo = Math.floor(eu), hi = Math.ceil(eu);
    if (table[lo] !== undefined && table[hi] !== undefined) return Math.round(((table[lo] + table[hi]) / 2) * 2) / 2;
    return table[k];
  }
  function parseShoeValue(value, gender) {
    if (value == null) return null;
    var s = String(value).toUpperCase();
    var mw = s.match(/M(?:EN'?S)?\s*(\d+(?:\.5)?)\s*\/\s*W(?:OMEN'?S)?\s*(\d+(?:\.5)?)/);
    if (mw) return parseFloat(gender === 'women' ? mw[2] : mw[1]);
    var wm = s.match(/W(?:OMEN'?S)?\s*(\d+(?:\.5)?)\s*\/\s*M(?:EN'?S)?\s*(\d+(?:\.5)?)/);
    if (wm) return parseFloat(gender === 'women' ? wm[1] : wm[2]);
    var n = parseFraction(s);
    if (n === null) return null;
    if (/\bEU\b|\bEUR\b/.test(s) || n >= 30) return euToUs(gender, n);
    if (/\bUK\b/.test(s)) return gender === 'women' ? n + 2 : n + 1;
    return n;
  }
  function mapShoe(usSize, allValues, availableValues, gender) {
    var metric = function (v) { return parseShoeValue(v, gender); };
    var exact = allValues.filter(function (v) { var m = metric(v); return m !== null && Math.abs(m - usSize) < 0.01; })[0] || null;
    var avail = availableValues.filter(function (v) { return metric(v) !== null; });
    var up = avail.filter(function (v) { return metric(v) >= usSize - 0.01; })
      .sort(function (a, b) { return metric(a) - metric(b); })[0];
    var nearest = up || avail.sort(function (a, b) { return metric(b) - metric(a); })[0] || null;
    if (exact && availableValues.indexOf(exact) > -1) nearest = exact;
    return { system: allValues.some(function (v) { return metric(v) !== null; }) ? 'shoe' : 'unknown', label: 'US ' + usSize, exact: exact, nearest: nearest };
  }
  function findSizeOptionIndex(optionNames) {
    var idx = -1;
    (optionNames || []).forEach(function (n, i) {
      var o = String(n).toLowerCase();
      if (idx === -1 && (o.indexOf('size') > -1 || o.indexOf('größe') > -1 || o.indexOf('groesse') > -1)) idx = i;
    });
    if (idx === -1) {
      (optionNames || []).forEach(function (n, i) {
        var o = String(n).toLowerCase();
        if (idx === -1 && (o.indexOf('waist') > -1 || o.indexOf('length') > -1)) idx = i;
      });
    }
    return idx;
  }
  /* selected: array of currently selected option values (null where unknown) */
  function pickVariant(variants, sizeIdx, sizeValue, selected) {
    var withSize = variants.filter(function (v) { return v.options[sizeIdx] === sizeValue; });
    var match = withSize.filter(function (v) {
      return v.options.every(function (o, i) { return i === sizeIdx || !selected || selected[i] == null || selected[i] === o; });
    });
    var avail = match.filter(function (v) { return v.available; })[0];
    if (avail) return { variant: avail, matchedOthers: true };
    var anyAvail = withSize.filter(function (v) { return v.available; })[0];
    if (anyAvail) return { variant: anyAvail, matchedOthers: false };
    return { variant: match[0] || withSize[0] || null, matchedOthers: false, soldOut: true };
  }

  var api = {
    letterIndex: letterIndex, chestEstimate: chestEstimate, chestToIndex: chestToIndex,
    recommendApparel: recommendApparel, detectSystem: detectSystem, mapApparel: mapApparel,
    parseWaistInseam: parseWaistInseam, womenNumericToIndex: womenNumericToIndex, euToIndex: euToIndex,
    shoeSizeFromLength: shoeSizeFromLength, parseShoeValue: parseShoeValue, mapShoe: mapShoe,
    findSizeOptionIndex: findSizeOptionIndex, pickVariant: pickVariant, SHOE_CHART: SHOE_CHART
  };
  if (typeof window !== 'undefined') window.HawcrestSA = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document === 'undefined') return;

  /* ---------- UI ---------- */
  function init() {
    var modal = document.getElementById('hc-sa');
    var cfgEl = document.getElementById('hc-sa-config');
    if (!modal || !cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var S = cfg.strings || {};
    var P = cfg.product || {};
    var body = modal.querySelector('[data-hc-sa-body]');
    var bar = modal.querySelector('.hc-progress__bar');
    var sizeIdx = findSizeOptionIndex(P.options || []);
    var state = {};
    var isShoe = cfg.kind === 'shoes';
    var totalSteps = isShoe ? 2 : 3;
    var email = cfg.email || 'contact@hawcrest.com';

    window.HawcrestModal.bindClose(modal);

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function withMail(text, subject) {
      var mail = cfg.email || 'contact@hawcrest.com';
      var link = '<a href="mailto:' + esc(mail) + '?subject=' + subject + '">' + esc(mail) + '</a>';
      var t = esc(text);
      return t.indexOf(esc(mail)) > -1 ? t.replace(esc(mail), link) : t + ' ' + link;
    }
    function progress(n) { if (bar) bar.style.width = Math.round((n / totalSteps) * 100) + '%'; }
    function mailLink() {
      return '<a href="mailto:' + esc(email) + '?subject=Size%20help">' + esc(email) + '</a>';
    }
    function helpHtml() {
      return '<p class="hc-note">' + withMail(S.help_text || 'Unsure? Email us for personal size help:', 'Size%20help') + '</p>';
    }
    function sizeValues(onlyAvailable) {
      var seen = {}, out = [];
      (P.variants || []).forEach(function (v) {
        if (onlyAvailable && !v.available) return;
        var val = v.options[sizeIdx];
        if (val != null && !seen[val]) { seen[val] = true; out.push(val); }
      });
      return out;
    }
    function productRoot() {
      return document.querySelector('[data-product-id="' + P.id + '"]') || document;
    }
    function selectedOptions() {
      var root = productRoot();
      return (P.options || []).map(function (name, i) {
        var idx = 'option' + (i + 1);
        var radio = root.querySelector('input[data-variant-input][data-index="' + idx + '"]:checked');
        if (radio) return radio.value;
        var sel = root.querySelector('select[data-variant-input][data-index="' + idx + '"]');
        if (sel) return sel.value;
        return null;
      });
    }
    function setPageSize(value) {
      var root = productRoot();
      var idx = 'option' + (sizeIdx + 1);
      var radios = root.querySelectorAll('input[data-variant-input][data-index="' + idx + '"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === value) {
          var label = root.querySelector('label[for="' + radios[i].id + '"]');
          if (label) label.click(); else radios[i].click();
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
      var sel = root.querySelector('select[data-variant-input][data-index="' + idx + '"]');
      if (sel) { sel.value = value; sel.dispatchEvent(new Event('change', { bubbles: true })); return true; }
      return false;
    }

    function heightOptions(name, from, to, selected) {
      var h = '';
      for (var i = from; i <= to; i++) h += '<option value="' + i + '"' + (i === selected ? ' selected' : '') + '>' + i + '</option>';
      return h;
    }

    function renderMeasure() {
      progress(0);
      var ft = state.ft || 5, inch = state.inch == null ? 8 : state.inch;
      var html = '<p class="hc-step__count">' + esc((S.step_of || 'Step {n} of {total}').replace('{n}', 1).replace('{total}', totalSteps)) + '</p>';
      html += '<p class="hc-modal__intro">' + esc(S.apparel_intro || 'Tell us a little about yourself and we will suggest a size for this item.') + '</p>';
      html += '<div class="hc-field"><span class="hc-field__label" id="hc-sa-h">' + esc(S.height_label || 'Height') + '</span><div class="hc-field__row">';
      html += '<div class="hc-input-suffix"><select class="hc-select" id="hc-sa-ft" aria-labelledby="hc-sa-h" aria-label="Feet" data-hc-autofocus>' + heightOptions('ft', 4, 6, ft) + '</select><span>ft</span></div>';
      html += '<div class="hc-input-suffix"><select class="hc-select" id="hc-sa-in" aria-label="Inches">' + heightOptions('in', 0, 11, inch) + '</select><span>in</span></div>';
      html += '</div></div>';
      html += '<div class="hc-field"><label class="hc-field__label" for="hc-sa-lb">' + esc(S.weight_label || 'Weight') + '</label>';
      html += '<div class="hc-input-suffix"><input class="hc-input" id="hc-sa-lb" type="number" inputmode="numeric" min="90" max="330" step="1" value="' + esc(state.lb || '') + '" placeholder="160"><span>lb</span></div></div>';
      html += '<p class="hc-error" role="alert" hidden></p>';
      html += '<div class="hc-nav"><span></span><button type="button" class="hc-btn" data-hc-next>' + esc(S.next || 'Next') + '</button></div>';
      html += helpHtml();
      body.innerHTML = html;
    }

    function optionGroup(q, key) {
      var html = '<p class="hc-step__label" id="hc-sa-' + key + '">' + esc(q.label) + '</p><ul class="hc-options" role="list" aria-labelledby="hc-sa-' + key + '">';
      q.options.forEach(function (o, i) {
        html += '<li><button type="button" class="hc-option" data-key="' + key + '" data-value="' + esc(o.value) + '" aria-pressed="' + (state[key] === o.value) + '"' + (key === 'build' && i === 0 ? ' data-hc-autofocus' : '') + '>' + esc(o.label) + '</button></li>';
      });
      return html + '</ul>';
    }

    function renderShape() {
      progress(1);
      var html = '<p class="hc-step__count">' + esc((S.step_of || 'Step {n} of {total}').replace('{n}', 2).replace('{total}', totalSteps)) + '</p>';
      html += optionGroup(S.build_question || { label: 'How would you describe your build?', options: [{ value: 'slim', label: 'Slim' }, { value: 'average', label: 'Average' }, { value: 'broad', label: 'Broad' }] }, 'build');
      html += optionGroup(S.fit_question || { label: 'How do you like your clothes to fit?', options: [{ value: 'snug', label: 'Snug' }, { value: 'regular', label: 'Regular' }, { value: 'relaxed', label: 'Relaxed' }] }, 'pref');
      html += '<p class="hc-error" role="alert" hidden></p>';
      html += '<div class="hc-nav"><button type="button" class="hc-link" data-hc-back>' + esc(S.back || 'Back') + '</button><button type="button" class="hc-btn" data-hc-result>' + esc(S.show_result || 'See my size') + '</button></div>';
      body.innerHTML = html;
      var f = body.querySelector('[data-hc-autofocus]');
      if (f) f.focus();
    }

    function renderShoe() {
      progress(0);
      var html = '<p class="hc-step__count">' + esc((S.step_of || 'Step {n} of {total}').replace('{n}', 1).replace('{total}', totalSteps)) + '</p>';
      html += '<p class="hc-modal__intro">' + esc(S.shoe_intro || 'Measure your foot and we will suggest a US size.') + '</p>';
      html += '<div class="hc-field"><label class="hc-field__label" for="hc-sa-foot">' + esc(S.foot_length_label || 'Foot length') + '</label><select class="hc-select" id="hc-sa-foot" data-hc-autofocus>';
      for (var e = 68; e <= 100; e++) {
        var v = e / 8;
        var whole = Math.floor(v), eighths = e % 8;
        var frac = ['', '⅛', '¼', '⅜', '½', '⅝', '¾', '⅞'][eighths];
        html += '<option value="' + v + '"' + ((state.foot || 10) === v ? ' selected' : '') + '>' + whole + (frac ? ' ' + frac : '') + '" (' + (v * 2.54).toFixed(1) + ' cm)</option>';
      }
      html += '</select></div>';
      html += '<p class="hc-note">' + esc(S.foot_help || 'Stand on a sheet of paper, mark your heel and longest toe, and measure the distance in inches. Measure both feet and use the longer one.') + '</p>';
      html += '<p class="hc-note">' + esc(S.between_sizes || 'Between sizes? We recommend going up.') + '</p>';
      html += '<div class="hc-nav"><span></span><button type="button" class="hc-btn" data-hc-result>' + esc(S.show_result || 'See my size') + '</button></div>';
      html += helpHtml();
      body.innerHTML = html;
    }

    function renderResult() {
      progress(totalSteps);
      var allValues = sizeValues(false), availValues = sizeValues(true);
      var res, detail = '';
      if (isShoe) {
        var us = shoeSizeFromLength(cfg.gender, state.foot);
        res = mapShoe(us, allValues, availValues, cfg.gender);
        detail = (cfg.gender === 'women' ? (S.womens || "Women's") : (S.mens || "Men's")) + ' US ' + us;
      } else {
        var rec = recommendApparel({ gender: cfg.gender, fit: cfg.fit, heightIn: state.ft * 12 + state.inch, weightLb: state.lb, build: state.build, pref: state.pref });
        res = mapApparel(rec, allValues, availValues, cfg.fit);
        detail = (cfg.gender === 'women' ? (S.womens_chart || "Based on our women's size chart") : (S.mens_chart || "Based on our men's size chart"));
      }
      var selected = selectedOptions();
      var html = '<p class="hc-step__label" id="hc-sa-result-title" tabindex="-1">' + esc(S.result_title || 'Your recommendation') + '</p>';
      var chosen = null, note = '', unavailable = false;
      if (res.exact) {
        var pickExact = pickVariant(P.variants || [], sizeIdx, res.exact, selected);
        if (pickExact.variant && !pickExact.soldOut) { chosen = { value: res.exact, pick: pickExact }; }
        else unavailable = true;
      } else if (res.nearest) {
        var pickNear = pickVariant(P.variants || [], sizeIdx, res.nearest, selected);
        if (pickNear.variant && !pickNear.soldOut) {
          chosen = { value: res.nearest, pick: pickNear };
          note = (S.nearest_text || 'Your calculated size ({size}) is not offered for this item, so we picked the closest available size.').replace('{size}', res.label);
        } else unavailable = true;
      } else unavailable = true;

      if (chosen) {
        html += '<div class="hc-result"><p class="hc-result__prefix">' + esc(S.result_prefix || 'We recommend') + '</p>';
        html += '<p class="hc-result__size">' + esc(chosen.value) + '</p><p class="hc-result__detail">' + esc(detail) + '</p></div>';
        if (note) html += '<p class="hc-note">' + esc(note) + '</p>';
        if (!chosen.pick.matchedOthers && (P.options || []).length > 1) html += '<p class="hc-note">' + esc(S.other_option_note || 'Your selected color is not available in this size, so we will add the first available option.') + '</p>';
        html += '<div class="hc-actions"><button type="button" class="hc-btn" data-hc-add="' + esc(chosen.pick.variant.id) + '">' + esc(S.add_button || 'Add size') + ' ' + esc(chosen.value) + '</button>';
        html += '<button type="button" class="hc-btn hc-btn--ghost" data-hc-select="' + esc(chosen.value) + '">' + esc(S.select_button || 'Select this size') + '</button></div>';
        html += '<p class="hc-error" role="alert" hidden></p>';
      } else {
        html += '<div class="hc-result"><p class="hc-result__prefix">' + esc(S.result_prefix || 'We recommend') + '</p><p class="hc-result__size">' + esc(res.label) + '</p><p class="hc-result__detail">' + esc(detail) + '</p></div>';
        html += '<p class="hc-note">' + withMail(S.unavailable_text || 'This size is currently not available for this item. Email us and we will help you find the right fit:', 'Size%20help') + '</p>';
      }
      html += helpHtml();
      html += '<div class="hc-nav"><button type="button" class="hc-link" data-hc-back>' + esc(S.back || 'Back') + '</button><button type="button" class="hc-btn hc-btn--ghost" data-hc-restart>' + esc(S.restart_label || 'Start over') + '</button></div>';
      body.innerHTML = html;
      var t = document.getElementById('hc-sa-result-title');
      if (t) t.focus();
      state.step = 'result';
    }

    function showError(msg) {
      var el = body.querySelector('.hc-error');
      if (el) { el.hidden = false; el.textContent = msg; }
    }

    body.addEventListener('click', function (e) {
      if (e.target.closest('[data-hc-next]')) {
        var ft = parseInt(document.getElementById('hc-sa-ft').value, 10);
        var inch = parseInt(document.getElementById('hc-sa-in').value, 10);
        var lb = parseInt(document.getElementById('hc-sa-lb').value, 10);
        var total = ft * 12 + inch;
        if (total < 58 || total > 80) { showError(S.height_error || 'Please choose a height between 4\'10" and 6\'8".'); return; }
        if (isNaN(lb) || lb < 90 || lb > 330) { showError(S.weight_error || 'Please enter a weight between 90 and 330 lb.'); return; }
        state.ft = ft; state.inch = inch; state.lb = lb;
        state.step = 'shape';
        renderShape();
        return;
      }
      var opt = e.target.closest('.hc-option');
      if (opt) {
        state[opt.getAttribute('data-key')] = opt.getAttribute('data-value');
        Array.prototype.forEach.call(body.querySelectorAll('.hc-option[data-key="' + opt.getAttribute('data-key') + '"]'), function (b) {
          b.setAttribute('aria-pressed', String(b === opt));
        });
        return;
      }
      if (e.target.closest('[data-hc-result]')) {
        if (isShoe) {
          state.foot = parseFloat(document.getElementById('hc-sa-foot').value);
        } else {
          if (!state.build || !state.pref) { showError(S.choose_error || 'Please answer both questions.'); return; }
        }
        renderResult();
        return;
      }
      if (e.target.closest('[data-hc-back]')) {
        if (isShoe || state.step === 'shape') { state.step = 'start'; isShoe ? renderShoe() : renderMeasure(); }
        else { state.step = 'shape'; renderShape(); }
        return;
      }
      if (e.target.closest('[data-hc-restart]')) { state = {}; isShoe ? renderShoe() : renderMeasure(); return; }
      var sel = e.target.closest('[data-hc-select]');
      if (sel) {
        setPageSize(sel.getAttribute('data-hc-select'));
        window.HawcrestModal.close();
        return;
      }
      var add = e.target.closest('[data-hc-add]');
      if (add) {
        add.disabled = true;
        var label = add.textContent;
        add.textContent = S.adding || 'Adding…';
        window.HawcrestModal.addToCart(add.getAttribute('data-hc-add'))
          .then(function (item) { add.textContent = S.added || 'Added'; setTimeout(function () { window.HawcrestModal.afterAdd(item); }, 350); })
          .catch(function () { add.disabled = false; add.textContent = label; showError(S.error || 'Sorry, this size could not be added. Please try again.'); });
      }
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-hc-open="size-assistant"]');
      if (!trigger) return;
      e.preventDefault();
      if (sizeIdx === -1) return;
      if (state.step !== 'result') { isShoe ? renderShoe() : renderMeasure(); }
      window.HawcrestModal.open(modal, trigger);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
